import { FC } from 'react';

import { SvgIconProps } from '@mui/material/SvgIcon';

import ArrowConnectionFill from './ArrowConnectionFill';
import ArrowLeft from './ArrowLeft';
import ArrowLevelUpFill from './ArrowLevelUpFill';
import ArrowRight from './ArrowRight';
import ArrowsConnection from './ArrowsConnection';
import Basket from './Basket';
import BatteryFullFill from './BatteryFullFill';
import Bell from './Bell';
import BellFill from './BellFill';
import Binoculars from './Binoculars';
import BinocularsFill from './BinocularsFill';
import Block from './Block';
import BoxOpen from './BoxOpen';
import Building from './Building';
import Bulb from './Bulb';
import Calendar from './Calendar';
import CalendarFill from './CalendarFill';
import CameraFill from './CameraFill';
import CarControl from './CarControl';
import CartFill from './CartFill';
import CheckMark from './CheckMark';
import CheckMarkFill from './CheckMarkFill';
import ChevronDown from './ChevronDown';
import ChevronLeft from './ChevronLeft';
import ChevronRight from './ChevronRight';
import ChevronUp from './ChevronUp';
import ChildOutline from './ChildOutline';
import Clip from './Clip';
//import Cloud from './Cloud';
import Coins from './Coins';
import ContactCard from './ContactCard';
import Contract from './Contract';
//import Copy from './Copy'
import Coupon from './Coupon';
import CreditCard from './CreditCard';
import Cross from './Cross';
import CrossFill from './CrossFill';
import CrosshairFill from './CrosshairFill';
import CursorArrow from './CursorArrow';
import CzechRepublic from './CzechRepublic';
import Data from './Data';
import Devices from './Devices';
import Diameter from './Diameter';
import DotFill from './DotFill';
import DoubleArrowRight from './DoubleArrowRight';
import Download from './Download';
import DownloadFill from './DownloadFill';
import DuckFill from './DuckFill';
import Envelope from './Envelope';
import EnvelopeFill from './EnvelopeFill';
import EnvelopeLetter from './EnvelopeLetter';
import Eraser from './Eraser';
import ExclamationMarkFill from './ExclamationMarkFill';
import ExclamationMarkTriangle from './ExclamationMarkTriangle';
import ExclamationMarkTriangleFill from './ExclamationMarkTriangleFill';
import Exit from './Exit';
import Expand from './Expand';
import EyeDisabledFill from './EyeDisabledFill';
import EyeFill from './EyeFill';
import FacebookFill from './FacebookFill';
import FileGeneric from './FileGeneric';
import FileGraphic from './FileGraphic';
import FilePdf from './FilePdf';
import FileTable from './FileTable';
import FileText from './FileText';
import Filter from './Filter';
import FixedLine from './FixedLine';
import FolderAdd from './FolderAdd';
import FolderOpen from './FolderOpen';
import FourSquaresFill from './FourSquaresFill';
import Gauge from './Gauge';
import Gift from './Gift';
import Hamburger from './Hamburger';
import HandShaking from './HandShaking';
import HardDriveFill from './HardDriveFill';
import Home from './Home';
import HomeFill from './HomeFill';
import Infinity from './Infinity';
import Info from './Info';
import InfoCircle from './InfoCircle';
import InfoFill from './InfoFill';
import Internet from './Internet';
import Key from './Key';
import Lanport from './Lanport';
//import LanportFill from './LanportFill';
import Laptop from './Laptop';
import Letter from './Letter';
import LetterPen from './LetterPen';
//import License from './License'
import Luggage from './Luggage';
import MegaphoneFill from './MegaphoneFill';
import MemoryCardFill from './MemoryCardFill';
import Minus from './Minus';
import MobileData from './MobileData';
import MobilePhone from './MobilePhone';
import MobilePhoneFill from './MobilePhoneFill';
import MojeO2 from './MojeO2';
import More from './More';
import MoreHorizontal from './MoreHorizontal';
//import Msoffice from './Msoffice';
import MultiplePersons from './MultiplePersons';
import NewMessage from './NewMessage';
import NewWindow from './NewWindow';
import ParentOutline from './ParentOutline';
import PenFill from './PenFill';
import Person from './Person';
import PersonFill from './PersonFill';
import PersonMultiple from './PersonMultiple';
import PersonQuestion from './PersonQuestion';
import PersonTie from './PersonTie';
import Phone from './Phone';
import PinFill from './PinFill';
import Plus from './Plus';
import PriceTag from './PriceTag';
import Puzzle from './Puzzle';
//import QuestionMarkCircle1 from './QuestionMarkCircle1'
import QuestionMarkFill from './QuestionMarkFill';
import Refresh from './Refresh';
import Registration from './Registration';
import Reload from './Reload';
import RoundedTriangleDownFill from './RoundedTriangleDownFill';
import RoundedTriangleRightFill from './RoundedTriangleRightFill';
import RoundedTriangleUpFill from './RoundedTriangleUpFill';
import Router from './Router';
import Rulers from './Rulers';
import RulersFill from './RulersFill';
import Save from './Save';
import Search from './Search';
import SearchFill from './SearchFill';
import SendMessage from './SendMessage';
import Service from './Service';
import Settings from './Settings';
import SettingsFill from './SettingsFill';
import Shrink from './Shrink';
import SimCard from './SimCard';
import SimFill from './SimFill';
import SimWireless from './SimWireless';
import SmileySad from './SmileySad';
import SpeechBubble from './SpeechBubble';
import SpeechBubbleFill from './SpeechBubbleFill';
import SpeechBubbles from './SpeechBubbles';
//import Star from './Star';
import StarFill from './StarFill';
import ThumbDown from './ThumbDown';
import ThumbDownFill from './ThumbDownFill';
import ThumbUp from './ThumbUp';
import ThumbUpFill from './ThumbUpFill';
import ToDo from './ToDo';
import TrashBin from './TrashBin';
import TvSet from './TvSet';
import TwitterFill from './TwitterFill';
import Umbrella from './Umbrella';
import Upload from './Upload';
import UploadFill from './UploadFill';
import Video from './Video';
import Wallet from './Wallet';
import WeightFill from './WeightFill';
import Wifi from './Wifi';
import Wrench from './Wrench';

export type IconClass =
  | 'o2-icon--arrow-connection-fill'
  | 'o2-icon--arrow-left'
  | 'o2-icon--arrow-level-up-fill'
  | 'o2-icon--arrow-right'
  | 'o2-icon--arrows-connection'
  | 'o2-icon--basket'
  | 'o2-icon--battery-full-fill'
  | 'o2-icon--bell'
  | 'o2-icon--bell-fill'
  | 'o2-icon--binoculars'
  | 'o2-icon--binoculars-fill'
  | 'o2-icon--block'
  | 'o2-icon--box-open'
  | 'o2-icon--building'
  //| 'o2-icon--bulb-fill'
  | 'o2-icon--calendar'
  | 'o2-icon--calendar-fill'
  | 'o2-icon--camera-fill'
  | 'o2-icon--car-control'
  | 'o2-icon--cart-fill'
  | 'o2-icon--checkmark'
  | 'o2-icon--checkmark-fill'
  | 'o2-icon--chevron-down'
  | 'o2-icon--chevron-left'
  | 'o2-icon--chevron-right'
  | 'o2-icon--chevron-up'
  | 'o2-icon--child-outline'
  | 'o2-icon--clip'
  //| 'o2-icon--cloud'
  | 'o2-icon--coins'
  | 'o2-icon--contact-card'
  | 'o2-icon--contract'
  //| 'o2-icon--copy'
  | 'o2-icon--coupon'
  | 'o2-icon--credit-card'
  | 'o2-icon--cross'
  | 'o2-icon--cross-fill'
  | 'o2-icon--crosshair-fill'
  | 'o2-icon--cursor-arrow1'
  | 'o2-icon--czech-republic'
  | 'o2-icon--data'
  | 'o2-icon--devices'
  | 'o2-icon--diameter'
  | 'o2-icon--dot-fill'
  | 'o2-icon--double-arrow-right'
  | 'o2-icon--download'
  | 'o2-icon--download-fill'
  | 'o2-icon--duck-fill'
  | 'o2-icon--envelope'
  | 'o2-icon--envelope-fill'
  | 'o2-icon--envelope-letter'
  | 'o2-icon--eraser'
  | 'o2-icon--exclamation-mark-fill'
  | 'o2-icon--exclamation-triangle'
  | 'o2-icon--exclamation-triangle-fill'
  | 'o2-icon--exit'
  | 'o2-icon--expand'
  | 'o2-icon--eye-disabled-fill'
  | 'o2-icon--eye-fill'
  | 'o2-icon--facebook-fill'
  | 'o2-icon--file-generic'
  | 'o2-icon--file-graphic'
  | 'o2-icon--file-pdf'
  | 'o2-icon--file-table'
  | 'o2-icon--file-text'
  | 'o2-icon--filter'
  | 'o2-icon--fixed-line'
  | 'o2-icon--folder-add'
  | 'o2-icon--folder-open'
  | 'o2-icon--four-squares-fill'
  | 'o2-icon--gauge'
  | 'o2-icon--gift'
  | 'o2-icon--hamburger'
  | 'o2-icon--hand-shaking'
  | 'o2-icon--hard-drive-fill'
  | 'o2-icon--home'
  | 'o2-icon--home-fill'
  | 'o2-icon--infinity'
  | 'o2-icon--info'
  | 'o2-icon--info-circle'
  | 'o2-icon--info-fill'
  | 'o2-icon--internet'
  | 'o2-icon--key'
  | 'o2-icon--lanport'
  //| 'o2-icon--lanport-fill'
  | 'o2-icon--laptop'
  | 'o2-icon--letter'
  | 'o2-icon--letter-pen'
  //| 'o2-icon--license'
  | 'o2-icon--luggage'
  | 'o2-icon--megaphone-fill'
  | 'o2-icon--memory-card-fill'
  | 'o2-icon--minus'
  | 'o2-icon--mobile-data'
  | 'o2-icon--mobile-phone'
  | 'o2-icon--mobile-phone-fill'
  | 'o2-icon--moje-o2'
  | 'o2-icon--more'
  | 'o2-icon--more-horizontal'
  //| 'o2-icon--msoffice'
  | 'o2-icon--multiple-persons'
  | 'o2-icon--new-message'
  | 'o2-icon--new-window'
  | 'o2-icon--parent-outline'
  | 'o2-icon--pen-fill'
  | 'o2-icon--person'
  | 'o2-icon--person-fill'
  | 'o2-icon--person-multiple'
  | 'o2-icon--person-question'
  | 'o2-icon--person-tie'
  | 'o2-icon--phone'
  | 'o2-icon--pin-fill'
  | 'o2-icon--plus'
  | 'o2-icon--price-tag'
  | 'o2-icon--puzzle'
  //| 'o2-icon--question-mark-circle1'
  | 'o2-icon--question-mark-fill'
  | 'o2-icon--refresh'
  | 'o2-icon--registration'
  | 'o2-icon--reload'
  | 'o2-icon--rounded-triangle-down-fill'
  | 'o2-icon--rounded-triangle-right-fill'
  | 'o2-icon--rounded-triangle-up-fill'
  | 'o2-icon--router'
  | 'o2-icon--rulers'
  | 'o2-icon--rulers-fill'
  | 'o2-icon--save'
  | 'o2-icon--search'
  | 'o2-icon--search-fill'
  | 'o2-icon--send-message'
  | 'o2-icon--service'
  | 'o2-icon--settings'
  | 'o2-icon--settings-fill'
  | 'o2-icon--shrink'
  | 'o2-icon--sim-card'
  | 'o2-icon--sim-fill'
  | 'o2-icon--sim-wireless'
  | 'o2-icon--smiley-sad'
  | 'o2-icon--speech-bubble'
  | 'o2-icon--speech-bubble-fill'
  | 'o2-icon--speech-bubbles'
  //| 'o2-icon--star'
  | 'o2-icon--star-fill'
  | 'o2-icon--thumb-down'
  | 'o2-icon--thumb-down-fill'
  | 'o2-icon--thumb-up'
  | 'o2-icon--thumb-up-fill'
  | 'o2-icon--to-do'
  | 'o2-icon--trash-bin'
  | 'o2-icon--tv-set'
  | 'o2-icon--twitter-fill'
  | 'o2-icon--umbrella'
  | 'o2-icon--upload'
  | 'o2-icon--upload-fill'
  | 'o2-icon--video'
  | 'o2-icon--wallet'
  | 'o2-icon--weight-fill'
  | 'o2-icon--wifi'
  | 'o2-icon--wrench';

//prettier-ignore
const icons = {
  'arrow-connection-fill': ArrowConnectionFill,
  'arrow-left': ArrowLeft,
  'arrow-level-up-fill': ArrowLevelUpFill,
  'arrow-right': ArrowRight,
  'arrows-connection': ArrowsConnection,
  'basket': Basket,
  'battery-full-fill': BatteryFullFill,
  'bell': Bell,
  'bell-fill': BellFill,
  'binoculars': Binoculars,
  'binoculars-fill': BinocularsFill,
  'block': Block,
  'box-open': BoxOpen,
  'building': Building,
  'bulb-fill': Bulb,
  'calendar': Calendar,
  'calendar-fill': CalendarFill,
  'camera-fill': CameraFill,
  'car-control': CarControl,
  'cart-fill': CartFill,
  'checkmark': CheckMark,
  'checkmark-fill': CheckMarkFill,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'child-outline': ChildOutline,
  'clip': Clip,
  //'cloud': Cloud,
  'coins': Coins,
  'contact-card': ContactCard,
  'contract': Contract,
  //'copy': Copy,
  'coupon': Coupon,
  'credit-card': CreditCard,
  'cross': Cross,
  'cross-fill': CrossFill,
  'crosshair-fill': CrosshairFill,
  'cursor-arrow1': CursorArrow,
  'czech-republic': CzechRepublic,
  'data': Data,
  'devices': Devices,
  'diameter': Diameter,
  'dot-fill': DotFill,
  'double-arrow-right': DoubleArrowRight,
  'download': Download,
  'download-fill': DownloadFill,
  'duck-fill': DuckFill,
  'envelope': Envelope,
  'envelope-fill': EnvelopeFill,
  'envelope-letter': EnvelopeLetter,
  'eraser': Eraser,
  'exclamation-mark-fill': ExclamationMarkFill,
  'exclamation-triangle': ExclamationMarkTriangle,
  'exclamation-triangle-fill': ExclamationMarkTriangleFill,
  'exit': Exit,
  'expand': Expand,
  'eye-disabled-fill': EyeDisabledFill,
  'eye-fill': EyeFill,
  'facebook-fill': FacebookFill,
  'file-generic': FileGeneric,
  'file-graphic': FileGraphic,
  'file-pdf': FilePdf,
  'file-table': FileTable,
  'file-text': FileText,
  'filter': Filter,
  'fixed-line': FixedLine,
  'folder-add': FolderAdd,
  'folder-open': FolderOpen,
  'four-squares-fill': FourSquaresFill,
  'gauge': Gauge,
  'gift': Gift,
  'hamburger': Hamburger,
  'hand-shaking': HandShaking,
  'hard-drive-fill': HardDriveFill,
  'home': Home,
  'home-fill': HomeFill,
  'infinity': Infinity,
  'info': Info,
  'info-circle': InfoCircle,
  'info-fill': InfoFill,
  'internet': Internet,
  'key': Key,
  'lanport': Lanport,
  //'lanport-fill': LanportFill,
  'laptop': Laptop,
  'letter': Letter,
  'letter-pen': LetterPen,
  //'license': License,
  'luggage': Luggage,
  'megaphone-fill': MegaphoneFill,
  'memory-card-fill': MemoryCardFill,
  'minus': Minus,
  'mobile-data': MobileData,
  'mobile-phone': MobilePhone,
  'mobile-phone-fill': MobilePhoneFill,
  'moje-o2': MojeO2,
  'more': More,
  'more-horizontal': MoreHorizontal,
  //'msoffice': Msoffice,
  'multiple-persons': MultiplePersons,
  'new-message': NewMessage,
  'new-window': NewWindow,
  'parent-outline': ParentOutline,
  'pen-fill': PenFill,
  'person': Person,
  'person-fill': PersonFill,
  'person-multiple': PersonMultiple,
  'person-question': PersonQuestion,
  'person-tie': PersonTie,
  'phone': Phone,
  'pin-fill': PinFill,
  'plus': Plus,
  'price-tag': PriceTag,
  'puzzle': Puzzle,
  //'question-mark-circle1': QuestionMarkCircle1,
  'question-mark-fill': QuestionMarkFill,
  'refresh': Refresh,
  'registration': Registration,
  'reload': Reload,
  'rounded-triangle-down-fill': RoundedTriangleDownFill,
  'rounded-triangle-right-fill': RoundedTriangleRightFill,
  'rounded-triangle-up-fill': RoundedTriangleUpFill,
  'router': Router,
  'rulers': Rulers,
  'rulers-fill': RulersFill,
  'save': Save,
  'search': Search,
  'search-fill': SearchFill,
  'send-message': SendMessage,
  'service': Service,
  'settings': Settings,
  'settings-fill': SettingsFill,
  'shrink': Shrink,
  'sim-card': SimCard,
  'sim-fill': SimFill,
  'sim-wireless': SimWireless,
  'smiley-sad': SmileySad,
  'speech-bubble': SpeechBubble,
  'speech-bubble-fill': SpeechBubbleFill,
  'speech-bubbles': SpeechBubbles,
  //'star': Star,
  'star-fill': StarFill,
  'thumb-down': ThumbDown,
  'thumb-down-fill': ThumbDownFill,
  'thumb-up': ThumbUp,
  'thumb-up-fill': ThumbUpFill,
  'to-do': ToDo,
  'trash-bin': TrashBin,
  'tv-set': TvSet,
  'twitter-fill': TwitterFill,
  'umbrella': Umbrella,
  'upload': Upload,
  'upload-fill': UploadFill,
  'video': Video,
  'wallet': Wallet,
  'weight-fill': WeightFill,
  'wifi': Wifi,
  'wrench': Wrench,
};

export type IconName = keyof typeof icons;

export interface ClassMappedIconProps extends SvgIconProps {
  /**
   * Legacy class of the icon (with the 'o2-icon--' prefix).
   */
  iconClass?: IconClass;

  /**
   * Name of the icon (without the 'o2-icon--' prefix).
   */
  iconName?: IconName;
}

/**
 * Icon allowing legacy icon-class-notation reuse. Exactly one of `iconClass` or `iconName` has to be provided!
 */
const ClassMappedIcon: FC<ClassMappedIconProps> = ({ iconClass, iconName, ...props }) => {
  if (!iconClass && !iconName) throw new Error('ClassMappedIcon needs either a iconClass or an iconName');

  if (iconClass && iconName) throw new Error('ClassMappedIcon needs either a iconClass or an iconName, not both');

  const Icon = icons[iconName ?? ((iconClass as IconClass).replace('o2-icon--', '') as IconName)];

  return <Icon {...props} />;
};

export default ClassMappedIcon;
